<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import Widget from './widget'

export default {
	page: {
		title: '360MDR Reports',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
		Layout,
		Widget
	},
	props: {
		name: {
			type: String,
			default: 'main.json'
		}
	},
	data() {
		return {
			startDateTime: null,
			endDateTime: null,
			startDateTimeShow: null,
			endDateTimeShow: null,
			error: null,
			title: 'Reporte Office 365',
			startEpoch: 0,
			endEpoch: 0,
			date: null,
			dateTimePicker: {
				enableTime: true,
				dateFormat: 'm/d/Y H:i',
			},
			dashboard: {
				"widgets": [
					{
            "source": "/sentinelone/value/count/timerange/other?collection=azure_events&tvariable=CreationTime&variable=_id",
						"id": "info2",
						"name": "Eventos totales en el rango de tiempo",
						"cols": "col-md-6",
						"height_class": "small",
						"component": "vindicator",
						"refresh": 60000,
						"range": true,
						"trend": false
					},
					{
            "source": "/sentinelone/value/count/timerange/other?collection=azure_events_alarms&tvariable=start&variable=_id",
						"id": "info4",
						"name": "Alarmas totales en el rango de tiempo",
						"cols": "col-md-6",
						"height_class": "small",
						"component": "vindicator",
						"refresh": 60000,
						"range": true,
						"trend": false
					},
					{
						"source": "/pan/xdr/agg/date/day?collection=azure_events&variable=CreationTime",
						"id": "widget2",
						"name": "CANTIDAD DE EVENTOS OFFICE 365",
						"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dbar",
						"type": "bar",
						"colors": ["#DC001E"],
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/agg/date/day?collection=azure_events_alarms&variable=start",
						"id": "widget2",
						"name": "CANTIDAD DE ALARMAS DE OFFICE 365",
						"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dbar",
						"type": "bar",
						"colors": ["#0084FF"],
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/agg/general?collection=azure_events_alarms&variables=severity&outvars=label&tvariable=start&limit=3",
						"source1": "/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.severity&outvars=label&tvariable=incident.incident.modification_time&limit=3",
						"id": "widget2",
						"name": "ALARMAS DE OFFICE 365 POR SEVERIDAD",
						"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dpie",
						"type": "donut",
            "colorsByLabel": {
              "high": "#DC001E",
              "medium": "#FECA00",
              "low": "#01AD00"
            },
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/agg/general?collection=azure_events_alarms&variables=type&outvars=label&tvariable=start&limit=10",
						"id": "widget2",
						"name": "ALARMAS DE OFFICE 365 POR TIPO",
            "name1": "TOP DE APLICACIONES EN EVENT0S",
            "cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dpie",
						"type": "donut",
						"colors": ['#0084FF', '#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
						"range": true,
						"refresh": 60000
					},
          {
            "source": "/pan/xdr/generic/top?collection=azure_events_alarms&variables=target,title&outvars=target,title&tvariable=end&limit=100&altorder=count&maxlength=100",
            "name": "TOP DE ALARMAS DE OFFICE 365",
            "id": "widget2222",
            "cols": "col-md-12",
            "height_class": "short_widget",
            "component": "multicolumn",
            "range": true,
            "refresh": 60000
          },
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=Operation&outvars=reference&tvariable=CreationTime&limit=10",
						"source1": "/pan/xdr/agg/general?collection=azure_events&variables=Operation&outvars=label&tvariable=CreationTime&limit=10",
            "name": "TOP DE OPERACIONES EN EVENTOS DE OFFICE 365",
						"cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"refresh": 60000
					},
					{
            "source": "/pan/xdr/alerts/top?collection=azure_events&variables=UserId&outvars=reference&tvariable=CreationTime&limit=10",
						"id": "widget2",
						"name": "TOP DE USUARIOS EN EVENTOS DE OFFICE 365",
						"cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"refresh": 60000
					},
					{
            "source": "/pan/xdr/alerts/top?collection=azure_events&variables=ClientIP&outvars=reference&tvariable=CreationTime&limit=10",
						"name": "TOP DE HOSTS EN EVENTOS DE OFFICE 365",
            "id": "widget21",
            "cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"refresh": 60000
					},
          {
            "source1": "/pan/xdr/alerts/top?collection=azure_events&variables=ClientIP&outvars=reference&tvariable=CreationTime&limit=10",
            "source": "/pan/xdr/alerts/top?collection=azure_events&variables=intelligence.geoip.country_name&outvars=reference&tvariable=CreationTime&limit=10",
            "name": "TOP DE PAÍSES EN EVENTOS DE OFFICE 365",
            "id": "widget222",
            "cols": "col-md-6",
            "height_class": "short_widget",
            "component": "multicolumn",
            "range": true,
            "refresh": 60000
          },
          {
            "source": "/pan/xdr/alerts/top?collection=azure_events&variables=AppName&outvars=reference&tvariable=CreationTime&limit=10",
            "name": "TOP DE APLICACIONES EN EVENTOS DE OFFICE 365",
            "id": "widget21",
            "cols": "col-md-6",
            "height_class": "short_widget",
            "component": "multicolumn",
            "range": true,
            "refresh": 60000
          },
          {
            "source": "/pan/xdr/alerts/top?collection=azure_events&variables=ClientApp&outvars=reference&tvariable=CreationTime&limit=10",
            "name": "TOP DE APLICACIONES CLIENTE EN EVENTOS DE OFFICE 365",
            "id": "widget222",
            "cols": "col-md-6",
            "height_class": "short_widget",
            "component": "multicolumn",
            "range": true,
            "refresh": 60000
          },
				]
			},
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			base: 0
		}
	},
	computed: {

	},
	mounted () {
		this.showModal()
	},
	methods: {
		showModal() {
			this.$refs['modal-datetime'].show()
		},
		handleOk (evt) {
			let that = this
			if (that.startDateTime === null) {
				that.error = "Please select a start date and time"
				evt.preventDefault()
			} else if (that.endDateTime === null) {
				that.error = "Please select an end date and time"
				evt.preventDefault()
			} else {
				that.startEpoch = parseInt(new Date(that.startDateTime).getTime()/1000)
				that.endEpoch = parseInt(new Date(that.endDateTime).getTime()/1000)
				that.base += 100
				that.title = 'Reporte Office 365'
				that.error = null
				that.startDateTimeShow = that.startDateTime
				that.endDateTimeShow = that.endDateTime
			}
		},
	},
}
</script>

<template>
	<Layout>
		<div class="container" style="max-width: 1420px !important;">
			<div class="row page-title">
				<div class="col-md-12 align-items-center" style="text-align:center">
					<h2 style="align:center;cursor:pointer;" v-on:click="showModal">
						{{ title }}&nbsp;
						<template v-if="startDateTimeShow !== null">
							{{ startDateTimeShow }}
							&nbsp;-&nbsp;
						</template>
						<template v-if="endDateTimeShow !== null">
							{{ endDateTimeShow }}
						</template>
					</h2>
				</div>
			</div>
			<div class="row">
				<template v-for="(widget, index) in dashboard.widgets">
					<Widget v-bind:key="index + base"
						:title="widget.name"
						:component="widget.component"
						:source="widget.source"
						:cols="widget.cols"
						:trend="widget.trend"
						:wclass="widget.class"
						:type="widget.type"
						:colors="widget.colors"
            :colorsByLabel="widget.colorsByLabel"
						:range="widget.range"
            :card_style="widget.card_style"
						:start="startEpoch"
						:end="endEpoch"
					/>
				</template>
			</div>
		</div>
		<b-modal
			ref="modal-datetime"
			id="incident.incident_id"
			size="xs"
			title="Select Time Range"
			:ok-only=true
			:centered=true
			:no-fade=true
			@ok="handleOk">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>Start</label>
					<flat-pickr
						v-model="startDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>End</label>
					<flat-pickr
						v-model="endDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
			</div>
			<div v-if="error !== null" class="row">
				<div class="col-md-12 severity_high" style="text-align:center">
					{{ error }}
				</div>
			</div>

		</b-modal>
	</Layout>
</template>


